module.exports = __webpack_public_path__ + "img/criminal-history.svg";